import type { app as Fr } from '../fr/app';

/** « app » in English — typed on the French: a missing sentence does not compile. */
export const app: typeof Fr = {
  monMotDePasse: 'My password',
  seDeconnecter: 'Sign out',
  pointsARegarder: (n) => `${n} ${n === 1 ? 'item' : 'items'} to check`,
  refuseTitre: 'This screen is not available to you',
  refuseAnalyses: 'Analytics and monitoring are reserved for the managers. Your role is the counter: today\'s queue, availability and payments.',
  refuseDroit: 'This screen requires a permission your account does not have. Ask the owner, who manages accounts and permissions.',
  revenirTaches: 'Back to my tasks',
  serveurTitre: 'The server is not responding',
  serveurConnecte: 'You are still signed in — ',
  serveurPasLaPeine: 'there is no need to sign in again',
  serveurInjoignable: '. The software simply cannot reach the server at the moment.',
  serveurVerifiez: 'Check your connection. If it works, the agency\'s server is temporarily unavailable. ',
  serveurAucunePerte: 'None of your data has been lost.',
  titreDocument: (marque) => `${marque} — Rental management`,
};
